import React, { useState } from "react"
import { Wrapper, RowWrapper, ToggleButton, Counter, EmptyList } from "./ComparrissonTray.styles"
import { CityCard } from "molecule"
import layers from './icons/layers.svg'
import down from './icons/down.svg'
import info from './icons/info.svg'


const ComparrissonTray = ({ cityData, imageData, selectCity, selectedUnit }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ToggleButton onClick={() => setIsOpen(!isOpen)}>
        <div>
          {cityData.length > 0 && <Counter>{cityData.length}</Counter>}

          {!isOpen && <img src={layers} alt='layer-icon' />}
          {isOpen && <img src={down} alt='collapse-icon' />}
        </div>
      </ToggleButton>


      <Wrapper isOpen={isOpen}>
        <h2>Pinned Destinations</h2>
        {!!cityData && cityData.length === 0 ?
          (<EmptyList><img id="infoIcon" src={info} alt="info icon" />Select destinations for comparrisson</EmptyList>)
          : <RowWrapper>
            {cityData.map((item, index) => {
              const { city, tempAvg, sunshineAvg, country, backgroundImg, numericId, selected } = item
              return (
                <CityCard
                  key={`${index.toString()}-${city}`}
                  numericId={numericId}
                  title={city}
                  secondaryText={country}
                  dataPoints={[
                    { title: "temp", value: tempAvg },
                    { title: "sunshine", value: sunshineAvg },
                  ]}
                  order={index}
                  backgroundImage={imageData[backgroundImg].childImageSharp.fluid}
                  backgroundImgTitle={backgroundImg}
                  selectCity={selectCity}
                  selected={selected}
                  type={"important"}
                  originalItem={item}
                  selectedUnit={selectedUnit}

                />
              )
            })
            }</RowWrapper>

        }
      </Wrapper>
    </>
  )
}

export default ComparrissonTray
